import declare from "dojo/_base/declare";
import DeleteController from "csi/action/DeleteController";
import locale from "csi/locale";

const CareAndCompositionLineDeleteController = declare(DeleteController, {

	/**
     * @override
     * Add confirmation message to delete two UOMConversions
     */
	confirmAction(params): void {
		if (this.getParent().Items.length === 1) {
			params.title = locale.resource("DeleteFinalLineItemCareAndCompositionTitle");
			params.message = locale.resource("DeleteFinalLineItemCareAndComposition");
		}
		this.inherited(arguments);
	},

});

export = CareAndCompositionLineDeleteController;